module.exports = __webpack_public_path__ + "static/media/fly0079.d9661ba0.webp";